export class AuthConfig {
    accessTokenStorageKey: string;
    scope: string;
    clientId: string;
    host: string;
    paths: {
        auth: string;
        logout: string;
    };

    constructor(
        accessTokenStorageKey: string,
        scope: string,
        clientId: string,
        host: string,
        paths: {
            auth: string,
            logout: string
        }
    ) {
        this.accessTokenStorageKey = accessTokenStorageKey;
        this.scope = scope;
        this.clientId = clientId;
        this.host = host;
        this.paths = paths;
    }
}

export class L1Config extends AuthConfig {
    idTokenStorageKey: string;
    redirectUrl: string;
    logoutRedirectUrl: string;
    override paths: {
        auth: string;
        logout: string;
        token: string;
        publicKey: string;
        account: string;
    };

    constructor(
        accessTokenStorageKey: string,
        scope: string,
        clientId: string,
        host: string,
        paths: {
            auth: string,
            logout: string,
            token: string,
            publicKey: string,
            account: string
        },
        idTokenStorageKey: string,
        redirectUrl: string,
        logoutRedirectUrl: string,
    ) {
        super(accessTokenStorageKey, scope, clientId, host, paths);
        this.idTokenStorageKey = idTokenStorageKey;
        this.redirectUrl = redirectUrl;
        this.logoutRedirectUrl = logoutRedirectUrl;
        this.paths = paths;
    }
}